export function NotFound() {
  return (
    <div className="fallback-route">
      <p>sitestash | 404</p>
    </div>
  )
}
